export { MadeWithPrezly } from './MadeWithPrezly';
